/** Saber quando é preciso voltar a colocar o balão do guia.
 *
 *  O guia media a posição uma vez por passo e ficava assim. Bastava
 *  abrir um painel ao lado, ou mudar a janela de tamanho, para o balão
 *  e o recorte ficarem onde o elemento ESTAVA: recorte ao lado do
 *  botão, balão meio fora do ecrã. Medi isso: a janela passou de 2200
 *  para 1200 px e o balão ficou 920 px fora, com o recorte 1010 px ao
 *  lado do alvo.
 *
 *  A vigia corre a cada quadro, por isso tem de ser barata e não pode
 *  escrever no DOM sem motivo: escrever a cada quadro obriga o browser
 *  a recalcular o desenho 60 vezes por segundo para nada. Daí a
 *  assinatura: lê-se o que interessa, compara-se com a leitura
 *  anterior, e só se coloca quando mudou.
 *
 *  Vive à parte e é pura, como o `posicionar.ts`, pela mesma razão:
 *  é a parte onde um erro não aparece em teste nenhum de
 *  comportamento, só a olho e já tarde.
 */

export interface Rectangulo {
  left: number
  top: number
  width: number
  height: number
}

/** O que, se mudar, obriga a recolocar o balão.
 *
 *  Arredonda-se ao pixel de propósito: um alvo dentro de um painel que
 *  está a animar devolve fracções que nunca estabilizam, e sem o
 *  arredondamento a vigia dispararia em todos os quadros para sempre.
 */
export function assinatura(
  alvo: Rectangulo | null,
  janela: { largura: number; altura: number },
  balaoAltura: number,
): string {
  const p = alvo
    ? [
        Math.round(alvo.left),
        Math.round(alvo.top),
        Math.round(alvo.width),
        Math.round(alvo.height),
      ]
    : ['sem-alvo']
  return [...p, janela.largura, janela.altura, balaoAltura].join(',')
}

/**
 * Faz a vigia: devolve a função que se chama a cada quadro.
 *
 * Coloca sempre à primeira, e depois só quando a leitura muda.
 */
export function criarVigia(
  ler: () => string,
  colocar: () => void,
): () => void {
  let anterior: string | null = null
  return () => {
    const agora = ler()
    if (agora === anterior) return
    anterior = agora
    colocar()
  }
}
